/**
 * QR gun tutorial illustrations: the layers and the points that place the badges on them.
 *
 * GENERATED by tools/qr-gun-render/anatomy/gen_art.mjs (do not edit by hand). The gun (Inateck BCST-35, the one
 * that pairs as «Hyper 160S») standing on the steel of the pass, drawn as isometric SVG with the Anatomy kit
 * (tools/qr-gun-render/anatomy/build.mjs) in the periscope tutorial's camera and materials. Every layer shares
 * one projection; the coordinates are CSS px of the 760x640 stage.
 */
import gunPass from '@/assets/qr-gun-tutorial/gun-pass.svg';
import gunShadow from '@/assets/qr-gun-tutorial/gun-shadow.svg';
import gunBody from '@/assets/qr-gun-tutorial/gun-body.svg';
import gunTrigger0 from '@/assets/qr-gun-tutorial/gun-trigger-0.svg';
import gunTrigger1 from '@/assets/qr-gun-tutorial/gun-trigger-1.svg';
import gunHead from '@/assets/qr-gun-tutorial/gun-head.svg';
import gunLed from '@/assets/qr-gun-tutorial/gun-led.svg';
import gunWaves from '@/assets/qr-gun-tutorial/gun-waves.svg';

export const STAGE = Object.freeze({ width: 760, height: 640 });

/** Each layer's box on the stage, in paint order. */
export const LAYERS = Object.freeze({
  gunPass: { src: gunPass, x: 0, y: 0, w: 760, h: 640 },
  gunShadow: { src: gunShadow, x: 0, y: 0, w: 760, h: 640 },
  gunBody: { src: gunBody, x: 0, y: 0, w: 760, h: 640 },
  gunTrigger0: { src: gunTrigger0, x: 0, y: 0, w: 760, h: 640 },
  gunTrigger1: { src: gunTrigger1, x: 0, y: 0, w: 760, h: 640 },
  gunHead: { src: gunHead, x: 0, y: 0, w: 760, h: 640 },
  gunLed: { src: gunLed, x: 0, y: 0, w: 760, h: 640 },
  gunWaves: { src: gunWaves, x: 0, y: 0, w: 760, h: 640 },
});

export const MOTION = Object.freeze({
  /** Where the tap badge presses: the trigger. */
  press: [321.3, 343.6],
  /** The status LED on top of the head. */
  led: [229.3, 263.8],
  /** Where the beep's arcs start (over the back of the head). */
  waves: [395.9, 110.9],
  /** The gun's centre on the stage — what the framing below centres. */
  gunCenter: [366.8, 311.1],
});

/** How each gun scene is framed: the gun centre lands on `center`, the stage scaled by `scale`. */
export const FRAMING = Object.freeze({
  power: { center: [366.8, 311.1], scale: 1 },
  notfound: { center: [366.8, 311.1], scale: 1 },
  sleep: { center: [366.8, 311.1], scale: 1 },
});
